import {
  IMG_CUSTOMS_INCHEON_T1,
  IMG_CUSTOMS_INCHEON_T2,
  IMG_CUSTOMS_GIMPO,
  IMG_CUSTOMS_GIMHAE,
  IMG_CUSTOMS_JEJU,
  IMG_CUSTOMS_MAP_GIMPO,
  IMG_CUSTOMS_MAP_GIMHAE,
  IMG_CUSTOMS_MAP_JEJU,
  IMG_CUSTOMS_INCHEON,
  IMG_CUSTOMS_MAP_INCHEON_T1_1,
  IMG_CUSTOMS_MAP_INCHEON_T1_2,
  IMG_CUSTOMS_MAP_INCHEON_T2_1,
  IMG_CUSTOMS_MAP_INCHEON_T2_2,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_01,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_02,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_03,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_04,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_01_MAP,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_02_MAP,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_03_MAP,
  IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_04_MAP,
  IMG_CRUISE_LOCATION_CUSTOMS_DONGGU,
  IMG_CRUISE_LOCATION_CUSTOMS_YEONGDOGU,
} from '@repo/assets';

type LocationCustoms = {
  key: 'incheonT1' | 'incheonT2' | 'gimpo' | 'gimhae' | 'jeju';
  name: string;
  engName: string;
};

type LocationCustomsCruise = {
  key: 'IncheonIntl' | 'IncheonCruise' | 'donggu' | 'yeongdogu';
  name: string;
  engName: string;
};

export const LOCATION_CUSTOMS: LocationCustoms[] = [
  {
    key: 'incheonT1',
    name: '인천공항 T1',
    engName: 'Incheon Airport T1',
  },
  {
    key: 'incheonT2',
    name: '인천공항 T2',
    engName: 'Incheon Airport T2',
  },
  {
    key: 'gimpo',
    name: '김포공항',
    engName: 'Gimpo Airport',
  },
  {
    key: 'gimhae',
    name: '김해공항',
    engName: 'Gimhae Airport',
  },
  {
    key: 'jeju',
    name: '제주공항',
    engName: 'Jeju Airport',
  },
];

export const LOCATION_CUSTOMS_DETAIL = {
  incheonT1: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F Check-in Counter B,E,J,L',
        kor: '3층 B, E, J, L 체크인 카운터 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON,
      map: IMG_CUSTOMS_MAP_INCHEON_T1_1,
    },
    {
      type: [{ eng: 'Boarding Area', kor: '면세 구역' }],
      location: {
        eng: '3F Gate 28',
        kor: '3층 중앙 28번 게이트 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON_T1,
      map: IMG_CUSTOMS_MAP_INCHEON_T1_2,
    },
  ],
  incheonT2: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F Check-in Counter E,G',
        kor: '3층 E, G 체크인 카운터 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON,
      map: IMG_CUSTOMS_MAP_INCHEON_T2_1,
    },
    {
      type: [{ eng: 'Boarding Area', kor: '면세 구역' }],
      location: {
        eng: '3F Gate 249, 270',
        kor: '3층 249번 게이트, 270번 게이트 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON_T2,
      map: IMG_CUSTOMS_MAP_INCHEON_T2_2,
    },
  ],
  gimpo: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '2F - GATE 1',
        kor: '2층 1번 Gate 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_GIMPO,
      map: IMG_CUSTOMS_MAP_GIMPO,
    },
  ],
  gimhae: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '2F - Gate 4 next to refund kiosk',
        kor: '2층 4번 Gate 환급 키오스크 옆',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_GIMHAE,
      map: IMG_CUSTOMS_MAP_GIMHAE,
    },
  ],
  jeju: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F - Gate 5',
        kor: '3층 5번 Gate 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_JEJU,
      map: IMG_CUSTOMS_MAP_JEJU,
    },
  ],
};

export const LOCATION_CUSTOMS_CRUISE: LocationCustomsCruise[] = [
  {
    key: 'IncheonIntl',
    name: '인천항 국제 여객 터미널',
    engName: 'Incheon Intl. Passenger Terminal',
  },
  {
    key: 'IncheonCruise',
    name: '인천항 크루즈 터미널',
    engName: 'Incheon Cruise Terminal',
  },
  {
    key: 'donggu',
    name: '부산항(동구)',
    engName: 'Busan Port (Dong-gu)',
  },
  {
    key: 'yeongdogu',
    name: '부산항(영동구)',
    engName: 'Busan Port (Yeongdo-gu)',
  },
];

export const LOCATION_CUSTOMS_DETAIL_CRUISE = {
  IncheonIntl: [
    {
      type: [
        {
          eng: 'Incheon Intl. Passenger Terminal',
          kor: '인천 국제 여객 터미널',
        },
      ],
      location: {
        eng: '2F Arrival Hall',
        kor: '2층 입국장',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_01,
      map: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_01_MAP,
      viewMap:
        'https://www.google.com/maps/place/%EC%9D%B8%EC%B2%9C%EA%B4%91%EC%97%AD%EC%8B%9C+%EC%97%B0%EC%88%98%EA%B5%AC+%EA%B5%AD%EC%A0%9C%ED%95%AD%EB%A7%8C%EB%8C%80%EB%A1%9C326%EB%B2%88%EA%B8%B8+57/data=!3m2!1e3!4b1!4m6!3m5!1s0x357b9d57703860ab:0xc4791dac7510c043!8m2!3d37.423859!4d126.6060975!16s%2Fg%2F11sb77zc9s?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D',
    },
    {
      type: [
        {
          eng: 'Incheon Intl. Passenger Terminal',
          kor: '인천 국제 여객 터미널',
        },
      ],
      location: {
        eng: '4F Departure Hall',
        kor: '4층 출국장',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_02,
      map: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_02_MAP,
      viewMap:
        'https://www.google.com/maps/place/%EC%9D%B8%EC%B2%9C%EA%B4%91%EC%97%AD%EC%8B%9C+%EC%97%B0%EC%88%98%EA%B5%AC+%EA%B5%AD%EC%A0%9C%ED%95%AD%EB%A7%8C%EB%8C%80%EB%A1%9C326%EB%B2%88%EA%B8%B8+57/data=!3m2!1e3!4b1!4m6!3m5!1s0x357b9d57703860ab:0xc4791dac7510c043!8m2!3d37.423859!4d126.6060975!16s%2Fg%2F11sb77zc9s?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D',
    },
  ],
  IncheonCruise: [
    {
      type: [{ eng: 'Incheon Cruise Terminal', kor: '인천항 크루즈 터미널' }],
      location: {
        eng: '1F Arrival Hall',
        kor: '1층 입국장',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_03,
      map: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_03_MAP,
      viewMap:
        'https://www.google.com/maps/place/%EC%9D%B8%EC%B2%9C%ED%95%AD+%ED%81%AC%EB%A3%A8%EC%A6%88%ED%84%B0%EB%AF%B8%EB%84%90/data=!3m1!1e3!4m10!1m2!2m1!1z7J247LKc6rSR7Jet7IucIOyXsOyImOq1rCDqta3soJztla3rp4zrjIDroZw0MzjrsojquLg!3m6!1s0x357b9d02c60c603d:0x1c2b23b05e559c54!8m2!3d37.4253828!4d126.5917218!15sCjXsnbjsspzqtJHsl63si5wg7Jew7IiY6rWsIOq1reygnO2VreunjOuMgOuhnDQzOOuyiOq4uFo8Ijrsnbjsspwg6rSR7Jet7IucIOyXsOyImOq1rCDqta3soJwg7ZWt66eMIOuMgOuhnCA0Mzgg67KI6ri4kgENZmVycnlfc2VydmljZZoBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VOWWIweHhOVXAzRUFF4AEA-gEECCMQHw!16s%2Fg%2F11fgjgfp67?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D',
    },
    {
      type: [{ eng: 'Incheon Cruise Terminal', kor: '인천항 크루즈 터미널' }],
      location: {
        eng: '2F Departure Hall',
        kor: '2층 출국장',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_04,
      map: IMG_CRUISE_LOCATION_CUSTOMS_INCHEON_04_MAP,
      viewMap:
        'https://www.google.com/maps/place/%EC%9D%B8%EC%B2%9C%ED%95%AD+%ED%81%AC%EB%A3%A8%EC%A6%88%ED%84%B0%EB%AF%B8%EB%84%90/data=!3m1!1e3!4m10!1m2!2m1!1z7J247LKc6rSR7Jet7IucIOyXsOyImOq1rCDqta3soJztla3rp4zrjIDroZw0MzjrsojquLg!3m6!1s0x357b9d02c60c603d:0x1c2b23b05e559c54!8m2!3d37.4253828!4d126.5917218!15sCjXsnbjsspzqtJHsl63si5wg7Jew7IiY6rWsIOq1reygnO2VreunjOuMgOuhnDQzOOuyiOq4uFo8Ijrsnbjsspwg6rSR7Jet7IucIOyXsOyImOq1rCDqta3soJwg7ZWt66eMIOuMgOuhnCA0Mzgg67KI6ri4kgENZmVycnlfc2VydmljZZoBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VOWWIweHhOVXAzRUFF4AEA-gEECCMQHw!16s%2Fg%2F11fgjgfp67?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D',
    },
  ],
  donggu: [
    {
      type: [{ eng: 'Busan Port (Dong-gu)', kor: '일반 구역' }],
      location: {
        eng: '3F Departure Hall Inside Terminal',
        kor: '3층 출국장',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_DONGGU,
      map: '',
      viewMap: '',
    },
  ],
  yeongdogu: [
    {
      type: [{ eng: 'Busan Port (Yeongdo-gu)', kor: '일반 구역' }],
      location: {
        eng: '1F Terminal CIQ Area\n(Customs, Immigration & Quarantine)',
        kor: '1층 터미널 CIQ 구역\n(Customs, Immigration & Quarantine)',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_CUSTOMS_YEONGDOGU,
      map: '',
      viewMap: '',
    },
  ],
};
